// src/components/PreviewPDF.js
import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from "../context/authContext";
import { pdf } from '@react-pdf/renderer';
import { useEstadoApp } from '../context/EstadoAppContext';
import { requisitos } from '../datos/requisitos';
import { barriosJsonATexto } from '../utils/barrios';
import InformeTecnicoPDF from './InformeTecnicoPDF';

// Importar imágenes para el PDF
import encabezadoImg from './informes/encabezado_A4.png';
import pieImg from './informes/pie_hoja_A4.png';

// Mapeo de modalidad para el informe: 1.b "Infraestructura de redes..." --> solo "Infraestructura"
const normalizarModalidad = (modalidad) =>
    typeof modalidad === 'string' && modalidad.includes('Infraestructura de redes')
        ? 'Infraestructura'
        : modalidad;

//ACCESIBLE desde la tabla de Inicio
const PreviewPDF = () => { //{ data, onClose } data se está pasando cuando se da click a generar informe de tabla Inicio
	const { token } = useContext(AuthContext)
	// 1. Todos los Hooks primero
	const { selectedObra } = useEstadoApp(); // toma los datos desde la fila seleccionada de la tabla de Inicio, pero no tiene todos los datos de formA

	const [isLoading, setIsLoading] = useState(true);
	const [documentosSeleccionados, setDocumentosSeleccionados] = useState([]);
	const [areaResponsable, setAreaResponsable] = useState();
	const [tipoSubsidio, setTipoSubsidio] = useState();
	//const [requisitosHabilitados, setRequisitosHabilitados] = useState([]);
	const [labelsSeleccionados, setLabelsSeleccionados] = useState([]);
	const [labelsNoSeleccionados, setLabelsNoSeleccionados] = useState([]);
	const [arrayLabelsSeleccionados, setArrayLabelsSeleccionados] = useState([]);
	const [arrayLabelsNoSeleccionados, setArrayLabelsNoSeleccionados] = useState([]);
	const [observacionesReporte, setObservacionesReporte] = useState('');

	//nuevo estado para todos las datos de formA
	const [formA_data, setFormA_data] = useState(null);

	// definir getRegistroById para traer todos los datos del registro
	const getRegistroById = async (id) => {
		const url = `/api/obras/${id}`;
		const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) };

		try {
			const response = await fetch(url, { headers });
			const data = await response.json();
			setFormA_data(data);
			//return data;
		} catch (error) {
			console.error('Error al buscar registro:', error);
			return null;
		}
	}

	// Función para obtener los datos del formulario B
	const getFormB_Tramitacion = async (idPartidoObra) => {
		if (!idPartidoObra) return;

		const urlFormB = `/api/form_b_tramitacion/${idPartidoObra}`;
		const headers = { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', ...(token ? { 'Authorization': `Bearer ${token}` } : {}) };

		try {
			const response = await fetch(urlFormB, { headers });

			if (!response.ok) {
				if (response.status === 404) {
					console.log("Formulario no encontrado");
				} else {
					throw new Error(`Error HTTP! status: ${response.status}`);
				}
				return;
			}

			const data = await response.json();
			setDocumentosSeleccionados(data.documentos_seleccionados || []);
			setObservacionesReporte(data.observaciones_reporte || '');

		} catch (error) {
			console.error('Error al buscar formulario por ID:', error);
			setDocumentosSeleccionados([]);
		} finally {
			setIsLoading(false);
		}
	};

	// 2. Un único useEffect para manejar la carga inicial y cambios
	useEffect(() => {
		// Si selectedObra existe, actualizamos el estado local
		if (selectedObra) {
			setAreaResponsable(selectedObra.area_responsable);
			setTipoSubsidio(selectedObra.tipo_subsidio);

			// Si tiene id, llamamos a la función para obtener el formulario B
			if (selectedObra.id_partido_obra) {
				getRegistroById(selectedObra.id);
				getFormB_Tramitacion(selectedObra.id_partido_obra);
			} else {
				// Si no tiene id, terminamos la carga
				setIsLoading(false);
			}
		} else {
			// Si no hay selectedObra, terminamos la carga y el componente mostrará el mensaje de error
			setIsLoading(false);
		}
	}, [selectedObra]); // Dependencia del useEffect

	useEffect(() => {
		// Si no hay documentos seleccionados, no hacemos nada.
		if (Object.keys(documentosSeleccionados).length === 0) {
			setArrayLabelsSeleccionados([]);
			setArrayLabelsNoSeleccionados([]);
			setLabelsSeleccionados([]);
			setLabelsNoSeleccionados([]);
			return;
		}

		const nuevosPresentados = [];
		const nuevosSinPresentar = [];
		let labelsPresentados = [];
		let labelsNoPresentados = [];
		let currentSection = '';

		const etapa = formA_data?.etapa;

		requisitos.forEach(req => {
			// Verifica si el requisito está habilitado según la etapa
			const etapaActual = etapa || 1;
			const requisitoEtapa = req.etapa;

			// Si el requisito tiene propiedad etapa, filtrar según la etapa actual
			if (requisitoEtapa !== undefined) {
				if (etapaActual === 2 && requisitoEtapa !== 2) return; // Etapa II: solo mostrar requisitos de etapa 2
				if (etapaActual !== 2 && requisitoEtapa !== 1) return; // Etapa I: solo mostrar requisitos de etapa 1
			}

			// Pasa las variables de estado como argumentos a isEnabled()
			const isEnabled = req.isSectionHeader
				? req.isEnabled(areaResponsable, tipoSubsidio)
				: req.isEnabled(areaResponsable, tipoSubsidio) && documentosSeleccionados.hasOwnProperty(req.id);

			if (isEnabled) {
				const item = {
					id: req.id,
					label: req.label,
					isSectionHeader: req.isSectionHeader || false,
					section: currentSection
				};

				if (req.isSectionHeader) {
					// Los encabezados van a ambas listas
					currentSection = req.label;
					nuevosPresentados.push(item);
					nuevosSinPresentar.push(item);
				} else {
					// Se separan según el estado de selección
					const isSelected = documentosSeleccionados[req.id] === true;
					if (isSelected) {
						nuevosPresentados.push({ ...item, presentado: true });
						labelsPresentados.push(item.label);
					} else {
						nuevosSinPresentar.push({ ...item, presentado: false });
						labelsNoPresentados.push(item.label);
					}
				}
			}
		});

		// Actualiza los estados de una sola vez
		setArrayLabelsSeleccionados(nuevosPresentados);
		setArrayLabelsNoSeleccionados(nuevosSinPresentar);
		setLabelsSeleccionados(labelsPresentados);
		setLabelsNoSeleccionados(labelsNoPresentados);

	}, [documentosSeleccionados, areaResponsable, tipoSubsidio, formA_data?.etapa]);

	// 3. Si no hay datos, mostramos un mensaje
	if (isLoading) {
		return (
			<div className="flex items-center justify-center h-screen">
				<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
			</div>
		);
	}

	if (!selectedObra || !formA_data) { //antes obraData
		return (
			<div className="p-4 text-center text-red-600">
				No hay datos para generar el informe.
			</div>
		);
	}

	// 4. Destructuring de formA_data (todos los datos de formA)
	const {
		nombre_obra,
		id_partido_obra,
		tipo_subsidio,
		area_responsable,
		etapa,
		tipo_microcredito,
		id_exp_proy_referencia,
		array_obras_expediente = [], //add 6-oct-2025
		partido_nombre,
		lc_21_localidad,//no es ---> localidad,
		//barrio,
		//barrio_rppvap_nombre,// no se usa porque se paso a usar el nuevo campo barrios_rppvap_multiples_jsonb
		barrios_rppvap_multiples_jsonb, // nuevo campo para multiples barrios de rppvap
		barrios_renabap_multiples_jsonb, // nuevo campo para multiples barrios de renabap
		barrio_otro_nombre,
		barrio_otro_nombre_jsonb,
		organismo_solicitante,
		organismo_otro,
		modalidad,
		monto_obra,
		tipo_contratacion,
		plazo_obra,
		beneficiarios,
		lc_22_identificacion_catastral,
		lc_22_1_datos_catastrales,
		lc_22_2_cuadro_calles,
		descripcion_proyecto,
		array_tipo_subtipo_proyecto,
		documentos,
		requisitosHabilitados,
		//observaciones_reporte,
		//labelsSeleccionados,
		//labelsNoSeleccionados,
		//arrayLabelsSeleccionados,
		//arrayLabelsNoSeleccionados,
		reportData
	} = formA_data || {}; //formA_data || {}
	console.log("formA_data ---->", formA_data)


	//convertir array de barrios en string separados por guiones medios
	//barriosJsonATexto soporta jsonb viejos con {value,label} sin nombre_barrio
	const barrios_rppvap_multiples_str = barriosJsonATexto(barrios_rppvap_multiples_jsonb);
	const barrios_renabap_multiples_str = barriosJsonATexto(barrios_renabap_multiples_jsonb);
	//barrios "Otro": se muestran en su propia línea, combinables con RPPVAP/RENABAP
	const barrios_otro_str = barriosJsonATexto(barrio_otro_nombre_jsonb, ', ') || barrio_otro_nombre || '';
	console.log("DEBUG: barrios_rppvap_multiples_str --->", barrios_rppvap_multiples_str)

	// 1. Usar find() para obtener el objeto "Proyecto" - add 6-oct-2025
	const objeto_proyecto = array_obras_expediente?.find(item => item && item.objeto_o === "Proyecto");

	// 2. Extraer el valor de expediente_o si el objeto fue encontrado - add 6-oct-2025
	let expediente_proyecto = null;
	if (objeto_proyecto) {
		expediente_proyecto = objeto_proyecto.expediente_o;
	}

	// Efecto para cargar los datos del formulario B de tramitación	


	const handleDownloadPDF = async () => {
		try {
			setIsLoading(true);

			// Organismo solicitante según tipo de subsidio (misma lógica que el preview)
			const organismoResuelto =
				tipo_subsidio === 'Subsidio a municipio'
					? `Municipio de ${partido_nombre || ''}`
					: tipo_subsidio === 'Subsidio a ONG'
						? `ONG ${organismo_solicitante || ''}`
						: organismo_otro || '';

			// El PDF se arma como TEXTO (react-pdf): flujo y salto de página nativos,
			// nunca corta una línea de texto por la mitad.
			const documento = pdf(
				<InformeTecnicoPDF
					datos={{
						nombre_obra,
						expediente_proyecto: expediente_proyecto || '',
						partido_nombre,
						lc_21_localidad,
						barrios_rppvap_multiples_str,
						barrios_otro_str,
						barrios_renabap_multiples_str,
						organismo_solicitante: organismoResuelto,
						modalidad: normalizarModalidad(modalidad),
						monto_obra: monto_obra != null && !isNaN(Number(monto_obra))
							? Number(monto_obra).toLocaleString('es-AR')
							: '',
						tipo_contratacion,
						plazo_obra,
						beneficiarios,
						datos_catastrales: lc_22_identificacion_catastral === 'SI' && lc_22_1_datos_catastrales
							? lc_22_1_datos_catastrales
							: null,
						cuadro_calles: lc_22_2_cuadro_calles,
						array_tipo_subtipo_proyecto: array_tipo_subtipo_proyecto || [],
						descripcion_proyecto,
						observacionesReporte: observacionesReporte || '',
						fecha_salida: new Date().toLocaleDateString('es-AR'),
					}}
				/>
			);

			const blob = await documento.toBlob();
			const url = URL.createObjectURL(blob);
			const nombreArchivo = selectedObra?.id_partido_obra
				? `informe_tecnico_obs_${selectedObra.id_partido_obra}.pdf`
				: 'informe_tecnico_obs.pdf';

			const link = document.createElement('a');
			link.href = url;
			link.download = nombreArchivo;
			document.body.appendChild(link);
			link.click();
			link.remove();
			URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Error al generar el PDF:', error);
		} finally {
			setIsLoading(false);
		}
	};


	//misntras se ejecuta el fetch mostrar un mensaje de loading
	if (isLoading) {
		return (
			<div className="flex items-center justify-center h-screen">
				<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
			</div>
		);
	}

	// Mover la verificación después de los Hooks
	if (!selectedObra) {
		return (
			<div className="p-4 text-center text-red-600">
				No hay datos para generar el informe.
			</div>
		);
	}

	{/*necesito que el div que contiene todo el contenido ocupe mas ancho de pantalla	 */ }
	return (
		<div className="bg-white p-8 px-10 sm:p-12 shadow-xl rounded-lg w-full max-w-6xl mx-auto my-6 font-sans border border-gray-200">
			<button
				onClick={handleDownloadPDF}
				className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
			>
				<svg className="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
					<path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
				</svg>
				Descargar PDF
			</button>

			<div className="p-10">{/* Todo dentro del pdfRef */}
				{/* Previsualización del encabezado */}
				{/*
				<div className="mb-6 overflow-hidden flex justify-end">
					<img
						src={encabezadoImg}
						alt="Encabezado del informe"
						className="h-auto"
						style={{ maxHeight: '100px', objectFit: 'contain' }}
					/>
				</div>
				*/}
				<div className="mb-6" data-pdf-omit="true">
					<img
						src={encabezadoImg}
						alt="Encabezado del informe"
						className="w-full h-auto max-h-[250px] object-cover"
					//style={{ maxHeight: '100px', objectFit: 'contain' }}
					/>
				</div>

				{/* Contenido principal */}

				<div className="text-center mb-6">
					<h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-1">
						Informe técnico con observaciones
					</h1>
					<h2 className="text-lg sm:text-xl text-gray-600">
						Dirección Provincial de Intervenciones Complementarias
					</h2>
				</div>

				<div className="grid grid-cols-1 sm:grid-cols-1 gap-x-8 gap-y-4 text-sm sm:text-base text-gray-700 mb-6 border-b pb-6">
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Nombre del Proyecto/alias:
							</strong>{' '}
							{nombre_obra}
						</p>
					</div>
					{/*en un div alineado a la derecha - add 6-oct-2025: cambiamos expediente x expediente_proyecto*/}
					<div className="text-right">
						<p>
							<strong className="font-semibold text-gray-900">
								Referente al Expediente:
							</strong>{' '}
							{expediente_proyecto ? expediente_proyecto : 'No especificado'}
						</p>
					</div>
					<p>
						<strong className="font-semibold text-gray-900">Localización:</strong>{' '}
						<strong className="font-semibold text-gray-900">Partido:</strong> {partido_nombre || 'No especificado'} - <strong className="font-semibold text-gray-900">Localidad:</strong> {lc_21_localidad || 'No especificado'} -<br />
						{(barrios_rppvap_multiples_str || barrios_otro_str || barrios_renabap_multiples_str) ? (
							<>
								{barrios_rppvap_multiples_str && (
									<strong className="font-semibold text-gray-900">Barrio RPPVAP:</strong>
								)}{' '}
								{barrios_rppvap_multiples_str}
								{barrios_otro_str && (
									<>
										{barrios_rppvap_multiples_str && <br />}
										<strong className="font-semibold text-gray-900">Barrio (Otros):</strong>{' '}
										{barrios_otro_str}
									</>
								)}
								{barrios_renabap_multiples_str && (
									<>
										{(barrios_rppvap_multiples_str || barrios_otro_str) && <br />}
										<strong className="font-semibold text-gray-900">Barrio RENABAP:</strong>{' '}
										{barrios_renabap_multiples_str}
									</>
								)}
							</>
						) : (
							<>
								<strong className="font-semibold text-gray-900">Barrio:</strong>{' '}
								No especificado
							</>
						)}
					</p>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Organismo Solicitante:
							</strong>
							{' '}
							{
								tipo_subsidio === 'Subsidio a municipio'
									? `Municipio de ${partido_nombre || ''}`
									: tipo_subsidio === 'Subsidio a ONG'
										? `ONG ${organismo_solicitante || ''}`
										: organismo_otro || ''
							}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">Modalidad:</strong>{' '}
							{normalizarModalidad(modalidad)}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Monto de obra en $:
							</strong>{' '}
							{Number(monto_obra).toLocaleString('es-AR')}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Tipo de contratación:
							</strong>{' '}
							{tipo_contratacion}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Plazo de obra:
							</strong>{' '}
							{plazo_obra}{plazo_obra ? ' días' : ''}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Beneficiarios:
							</strong>{' '}
							{beneficiarios}
						</p>
					</div>
					<div>
						<p>
							<strong className="font-semibold text-gray-900">
								Ubicación del Proyecto
							</strong>{' '}
							<br />

							{lc_22_identificacion_catastral === 'SI' && (
								<div>
									<p>
										<strong className="font-semibold text-gray-900">- Datos catastrales: </strong>
										{' '}{lc_22_1_datos_catastrales}
									</p>
								</div>
							)}

							<br />
							<div>
								<div style={{ whiteSpace: 'pre-wrap' }}>
									<strong className="font-semibold text-gray-900">- Cuadro de calles: </strong>
									{' '}{lc_22_2_cuadro_calles}
								</div>
							</div>
							<br />
						</p>
					</div>
				</div>

				<div className="mb-6">
					<h3 className="text-xl font-semibold text-gray-800 mb-4">
						Descripción del proyecto
					</h3>
					{array_tipo_subtipo_proyecto?.length > 0 ? (
						<ul className="list-disc list-inside space-y-1 text-gray-700">
							{array_tipo_subtipo_proyecto?.map((item, index) => (
								<li key={index}>
									<strong className="font-medium">{item.tipo}:</strong>{' '}
									{item.subtipo} - {item.cantidad} - {item.unidad}
								</li>
							))}
						</ul>
					) : (
						<p className="text-gray-500 italic">No se especificaron ítems de obra.</p>
					)}
				</div>

				{descripcion_proyecto && descripcion_proyecto.trim().length > 0 && (
					<div className="mb-6">
						<div className="text-gray-700" style={{ whiteSpace: 'pre-wrap' }}>{descripcion_proyecto}</div>
					</div>
				)}

				<div className="border-t pt-6">
					<h1 className="text-center text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
						Observaciones
					</h1>
					<p className="text-gray-700 mb-4">
						A partir del análisis de la propuesta y la documentación técnica
						presentada, la Dirección Provincial de Intervenciones Complementarias
						realiza las siguientes observaciones:
					</p>
					<div className="text-gray-700" style={{ whiteSpace: 'pre-wrap' }}>
						{observacionesReporte}
					</div>

					{/* --- OCULTADO (2026-09-21): bloques de documentación presentada / faltante ---
					<div className="space-y-2 text-gray-700">
						<strong className="font-semibold text-gray-900">
							Se presentó la siguiente documentación:
						</strong>{' '}
						{arrayLabelsSeleccionados.length > 0 ? (
							<ul className="list-disc list-inside space-y-1 text-gray-700">
								{arrayLabelsSeleccionados.map((item) => {
									// Verificamos si es un encabezado
									if (item.isSectionHeader) {
										// Si es un encabezado, lo renderizamos como un <h3> o similar
										return (
											<h3 key={item.id} style={{ marginTop: '20px', marginBottom: '10px' }}>
												{item.label}
											</h3>
										);
									} else {
										// Si no es un encabezado, lo renderizamos como un elemento de lista <li>
										return (
											<li key={item.id} className="documento-presentado">
												{item.label}
											</li>
										);
									}
								})}
							</ul>
						) : (
							<p className="text-gray-500 italic">Sin documentos presentados.</p>
						)}


						<strong className="font-semibold text-gray-900">
							Documentación faltante, incompleta y/o a corregir:
						</strong>{' '}
						{arrayLabelsNoSeleccionados.length > 0 ? (
							<ul className="list-disc list-inside space-y-1 text-gray-700">
								{arrayLabelsNoSeleccionados.map((item) => {
									// Verificamos si es un encabezado
									if (item.isSectionHeader) {
										// Si es un encabezado, lo renderizamos como un <h3> o similar
										return (
											<h3 key={item.id} style={{ marginTop: '20px', marginBottom: '10px' }}>
												{item.label}
											</h3>
										);
									} else {
										// Si no es un encabezado, lo renderizamos como un elemento de lista <li>
										return (
											<li key={item.id} className="documento-presentado">
												{item.label}
											</li>
										);
									}
								})}
							</ul>
						) : ''}
					</div>
					--- FIN OCULTADO */}
				</div>



				<div className="mt-8 text-right text-sm text-gray-500">
					<p>Fecha de salida: {new Date().toLocaleDateString('es-AR')}</p>
					<p>.</p>
				</div>



				{/* Previsualización del pie de página */}
				<div className="mb-6" data-pdf-omit="true">
					<img
						src={pieImg}
						alt="Pie de página del informe"
						className="w-full h-auto"
					//className="w-full h-auto max-h-[250px] object-cover"
					// Si necesitas limitar la altura máxima, puedes añadir:
					// style={{ maxHeight: '250px', objectFit: 'contain' }}
					// Pero esto podría impedir que la imagen ocupe todo el ancho si es muy alta.
					/>
				</div>

				{/* Previsualización del pie de página:
				un grid de dos clumnas. Una con texto, la otra con la imagen
				Por ahora solo usar un div con todo el texto y la imagen
				*/}
				{/*
				<div className="mt-6 border border-gray-200 rounded-lg overflow-hidden">
					<div className="grid grid-cols-4 gap-4 p-4 bg-white items-center">
						Primera columna - Texto (1/4 del ancho)
						<div className="col-span-1 text-left">
							<p className="text-xs text-gray-500 mt-1">Subsecretaría de Hábitat de la Comunidad</p>
							<p className="text-sm text-gray-700 font-medium">Dirección Provincial de Intervenciones Complementarias</p>
							<p className="text-xs text-gray-500 mt-1">Ministerio de Desarrollo Social</p>
						</div>
						
						Segunda columna - Imagen (3/4 del ancho)
						<div className="col-span-3 flex justify-end items-center">
							<img
								src={pieImg}
								alt="Pie de página del informe"
								className="w-full max-w-xs"
								style={{ maxHeight: '50px', objectFit: 'contain' }}
							/>
						</div>
					</div>
				</div>
				*/}

			</div>
		</div>
	);
};

export default PreviewPDF;